import {Model} from "vue-mc";
import {Person} from "./Person";
import {
  required,
  numeric,
  min,
} from "vue-mc/validation"

export class Donation extends Model
{
  static STATUS = {
    REFUNDED: 'refunded',
    CREATED: 'created',
    PROCESSING: 'processing',
    PAID: 'paid',
  }

    defaults() {
        return {
            id: null,
            status: null,
            person: new Person(),
            amount: 0,
            subscribeToNewsLetter: true,
        }
    }

    validation() {
      return {
        amount: [required, numeric.and(min(4.9))]
      }
    }

  options() {
    return {
      validateOnChange: true,
    }
  }
}
